import { useFacilityCountsQuery } from './useFacilityCountsQuery';
import { useFacilityRolesQuery } from './useFacilityRolesQuery';
import { useRoleUsersQuery } from './useRoleUsersQuery';
import { useUserRoleAssignmentsQuery } from './useUserRoleAssignmentsQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface UserRoleRevokeMutationParams {
  assignmentId: string;
}

export const useUserRoleRevokeMutation = createMutationHook(
  'settings.teamPermissions.userRoleRevoke',
  (params: UserRoleRevokeMutationParams) => ({
    coreUserRoleRevoke: {
      __args: {
        id: params.assignmentId,
      },
    },
  }),
  {
    invalidateQueries: [
      useUserRoleAssignmentsQuery,
      useRoleUsersQuery,
      useFacilityRolesQuery,
      useFacilityCountsQuery,
    ],
  },
);
